import { ColumnChart } from 'components/ColumnChart'
import { ContentNotAvailable } from 'components/ContentNotAvailable'
import { DrinksMix } from 'components/DrinksMix'
import { MainBox } from 'components/MainBox'
import { DrinkIDs, drinkSpecs } from 'components/MainComponent/drinkSpecs'
import { labelStyles } from 'components/MainComponent/LabelStyles'
import { Textbuilder } from 'components/MainComponent/textBuilder'
import { ReadDataFromWindow } from 'components/WindowCommunication'
import { useLabels } from 'Hooks/useLabels'
import { useState } from 'react'

const drinkAbbr2drinkName: { [key: string]: { de: string; fr: string } } = {
  cap: { de: 'Cappuccino', fr: 'cappuccino' },
  cre: { de: 'Café Crème', fr: 'café noir' },
  esp: { de: 'Espresso', fr: 'expresso' },
  fil: { de: 'Filterkaffee', fr: 'café filtre' },
  ris: { de: 'Ristretto', fr: 'ristretto' },
  sch: { de: 'Schale', fr: 'bol de café' },
  lat: { de: 'Latte Macchiato', fr: 'latte macchiato' },
  flatwhite: { de: 'Flat White', fr: 'flat white' }
}

function calculateDataForFlowchart (data: drinkCountType) {
  let flowColumnData: FlowColumData[] = []
  let valueSum = Object.values(data).reduce((a, b) => a + b, 0)
  Object.entries(data).forEach(([key, value]: [DrinkIDs, number]) => {
    let valueInPercent = Math.round((value * 100) / valueSum)
    let label = drinkSpecs[key].name_de
    let abbr = drinkSpecs[key].abbr
    let id = drinkSpecs[key].id
    flowColumnData.push({
      brew: drinkSpecs[key].brew,
      value: value,
      valueInPercent,
      label,
      abbr,
      id,
      cup: drinkSpecs[key].cup
    })
  })
  return flowColumnData
}
export const Part7 = ({
  tenant,
  colorMode
}: {
  tenant: Tenant | undefined
  colorMode: 'light' | 'dark' | undefined
}) => {
  const [userinputs, setUserInputs] = useState<UserInputsType>({})
  const [drinksMix, setDrinksmix] = useState<{ [key: string]: number }>()
  const [voteStats, setvoteStats] = useState<VoteStatsType>({})
  const [drinkCounts, setDrinkCounts] = useState<FlowColumData[]>([])

  const Labels = useLabels(labelStyles)
  function handleNewData (data: dbDataType) {
    if (data && data.userinputs && data.userinputs.weight)
      setUserInputs(data.userinputs)

    if (data && data.voteStats && data.voteStats.sum)
      setvoteStats(data.voteStats)

    if (data && data.drinksmix) setDrinksmix(data.drinksmix)

    if (data && data.drinks)
      setDrinkCounts(calculateDataForFlowchart(data.drinks))
  }

  const lang = tenant?.lang

  const userDrinksMix = userinputs
    ? Object.entries(userinputs)
        .filter(
          f =>
            f[0] &&
            f[1] &&
            !['weight', 'sum', 'caffeine', 'health'].includes(f[0]) &&
            f[1] &&
            f[1] > 0
        )
        .sort((a, b) => a[0].localeCompare(b[0]))
        .map(m => m[0].slice(0, 3))
        .join('_')
    : ''
  const drinkRank = drinkCounts.sort((a, b) => b.value - a.value)
  const mostLikedDrink: string | undefined = drinkRank[0]?.id
  const secondMostLikedDrink: string | undefined = drinkRank[1]?.id
  const filtercofffeeRank = drinkRank.findIndex(f => f.id === 'filter') + 1

  const mixRank =
    drinksMix &&
    Object.entries(drinksMix)
      .filter(f => f[0].includes('_'))
      .sort((a, b) => b[1] - a[1])
  // if(!mixRank) return null

  const mostPopularMix =
    mixRank &&
    mixRank.length > 0 &&
    mixRank[0][0]
      .split('_')
      .map(m => drinkAbbr2drinkName[m][tenant?.lang || 'de'])

  const mostPopularMixPercent =
    voteStats?.sum && mixRank?.length
      ? (mixRank[0][1] * 100) / voteStats.sum
      : undefined

  const userDrinksMostPopularMix =
    mixRank && mixRank.length > 0 && userDrinksMix === mixRank[0][0]

  const userDrinksMixPercent =
    userDrinksMix.includes('_') &&
    voteStats &&
    voteStats.sum &&
    drinksMix &&
    (drinksMix[userDrinksMix] * 100) / voteStats.sum

  const combinationsOnly =
    drinksMix && mixRank?.length ? Object.fromEntries(mixRank) : undefined

  const userDrinksSingle = userDrinksMix.includes('_') ? false : true
  const userSingleDrinkPercent = drinkRank.find(
    f => f.abbr === userDrinksMix
  )?.valueInPercent

  console.log('-----', {
    userDrinksSingle,
    drinksMix,
    userDrinksMix,
    a: drinksMix?.[userDrinksMix]
  })
  return (
    <>
      <ReadDataFromWindow callback={handleNewData} />
      {!userinputs.weight && (
        <>
          <MainBox
            content={
              <div
                style={{
                  color: 'var(--text-color)',
                  letterSpacing: '.5px'
                }}
              >
                <Labels userRelationBox>
                  {lang === 'de' ? (
                    <>
                      So unterscheidet sich Ihre Art, Kaffee zu trinken, von
                      anderen
                    </>
                  ) : (
                    <>
                      Voici comment vous buvez votre café par rapport aux autres
                    </>
                  )}
                </Labels>
              </div>
            }
          />
          <ContentNotAvailable>
            {lang === 'de' ? (
              <>
                Welche Kaffeegetränke sind am beliebtesten? Wie viele
                Teilnehmende haben denselben Geschmack wie Sie? Finden Sie es
                heraus, indem Sie ganz oben Ihren Kaffee-Konsum angeben.
              </>
            ) : (
              <>
                Quelles sont les boissons au café les plus populaires? Combien
                de participants ont les mêmes goûts que vous?
                Découvrez-le en indiquant tout en haut ce que vous buvez comme
                café.
              </>
            )}
          </ContentNotAvailable>
        </>
      )}
      {userinputs.weight && (
        <>
          <MainBox
            content={
              <div
                style={{
                  color: 'var(--text-color)',
                  letterSpacing: '.5px'
                }}
              >
                <p>
                  <Labels userRelationBox>
                    {lang === 'de'
                      ? 'Das sind die beliebtesten Kaffeegetränke und Kombinationen'
                      : 'Voici les types de café les plus populaires et les combinaisons les plus fréquentes'}
                  </Labels>
                </p>
              </div>
            }
          />
          <p>
            <>
              {!!(secondMostLikedDrink && mostLikedDrink && userinputs) &&
                (lang === 'de'
                  ? Textbuilder()
                      .add('Das beliebteste Kaffeegetränk')
                      .break()
                      .add(' der Teilnehmenden ist ')
                      .break()
                      .hash(mostLikedDrink, {
                        ristretto: 'Ristretto.',
                        espresso: 'Expresso.',
                        cappuccino: 'Cappuccino.',
                        creme: 'Café Crème.',
                        filter: 'Filterkaffee.',
                        schale: 'Schale.',
                        latte: 'Latte Macchiato.'
                      })
                      .break()
                      .conditional(mostLikedDrink === 'filter', {
                        true: ' Er war vor der Einführung von Vollautomaten in der Schweiz noch am verbreitetsten und feierte erst in den letzten Jahren wieder ein kleines Comeback.',
                        false: ``
                      })
                      .add(' Auf dem ')
                      .break()
                      .add('zweiten Platz')
                      .break()
                      .add(' folgt ')
                      .break()
                      .hash(
                        secondMostLikedDrink,
                        !!userinputs[secondMostLikedDrink]
                          ? {
                              ristretto:
                                'Ristretto, den Sie ebenfalls trinken.',
                              espresso: 'Espresso, den Sie ebenfalls trinken.',
                              cappuccino:
                                'Cappuccino, den Sie ebenfalls trinken.',
                              creme: 'Café Crème, das Sie ebenfalls trinken.',
                              filter: 'Filterkaffe, den Sie ebenfalls trinken.',
                              schale: 'Schale, die Sie ebenfalls trinken.',
                              latte:
                                'Latte Macchiato, den Sie ebenfalls trinken.'
                            }
                          : {
                              ristretto: 'Ristretto.',
                              espresso: 'Espresso.',
                              cappuccino: 'Cappuccino.',
                              creme: 'Café Crème.',
                              filter: 'Filterkaffe.',
                              schale: 'Schale.',
                              latte: 'Latte Macchiato.'
                            }
                      )

                      .conditional(secondMostLikedDrink === 'filter', {
                        true: 'Er war vor der Einführung von Vollautomaten in der Schweiz noch am verbreitetsten und feierte erst in den letzten Jahren wieder ein kleines Comeback.',
                        false: ``
                      })
                      .conditional(
                        mostLikedDrink !== 'filter' &&
                          secondMostLikedDrink !== 'filter',
                        {
                          true: ` Der Filterkaffee, der vor der Einführung von Vollautomaten in der Schweiz noch am verbreitetsten war und erst in den letzten Jahren wieder ein kleines Comeback gefeiert hat, liegt auf Platz ${filtercofffeeRank}.`,
                          false: ''
                        }
                      )
                      .array()
                      .map((m, i) => {
                        // if ([0, 2, 4].includes(i)) {
                        //   return (
                        //     <span key={i}>
                        //       <b>{m}</b>
                        //     </span>
                        //   )
                        // }
                        return <span key={i}>{m}</span>
                      })
                  : Textbuilder()
                      .add('Le café le plus populaire')
                      .break()
                      .add(' des participants est ')
                      .break()
                      .hash(mostLikedDrink, {
                        ristretto: 'le ristretto.',
                        espresso: "l'espresso.",
                        cappuccino: 'le cappuccino.',
                        creme: 'le café noir.',
                        filter: 'le café filtre.',
                        schale: 'le bol de café.',
                        latte: 'le latte macchiato.'
                      })
                      .break()
                      .conditional(mostLikedDrink === 'filter', {
                        true: " Il était encore le plus répandu en Suisse avant l'introduction des machines à café entièrement automatiques et n'a fait un petit retour que ces dernières années.",
                        false: ``
                      })
                      .add(' À la ')
                      .break()
                      .add('deuxième place')
                      .break()
                      .add(' vient ')
                      .break()
                      .hash(
                        secondMostLikedDrink,
                        !!userinputs[secondMostLikedDrink]
                          ? {
                              ristretto:
                                'le ristretto, que vous buvez également.',
                              espresso: "l'expresso, que vous buvez également.",
                              cappuccino:
                                'le cappuccino, que vous buvez également.',
                              creme: 'le café noir, que vous buvez également.',
                              filter:
                                'le café filtre, que vous buvez également.',
                              schale:
                                'le café au lait, que vous buvez également.',
                              latte:
                                'le latte macchiato, que vous buvez également.'
                            }
                          : {
                              ristretto: 'ristretto.',
                              espresso: 'expresso.',
                              cappuccino: 'cappuccino.',
                              creme: 'café noir.',
                              filter: 'café filtre.',
                              schale: 'bol de café.',
                              latte: 'latte Macchiato.'
                            }
                      )

                      .conditional(secondMostLikedDrink === 'filter', {
                        true: "Il était encore le plus répandu en Suisse avant l'introduction des machines à café entièrement automatiques et n'a fait un petit retour que ces dernières années.",
                        false: ``
                      })
                      .conditional(
                        mostLikedDrink !== 'filter' &&
                          secondMostLikedDrink !== 'filter',
                        {
                          true: ` Le café filtre, qui était encore le plus répandu en Suisse avant l'introduction des machines à café automatiques et qui n'a fait un petit come-back que ces dernières années, occupe la place ${filtercofffeeRank}.`,
                          false: ''
                        }
                      )
                      .array()
                      .map((m, i) => {
                        // if ([0, 2, 4].includes(i)) {
                        //   return (
                        //     <span key={i}>
                        //       <b>{m}</b>
                        //     </span>
                        //   )
                        // }
                        return <span key={i}>{m}</span>
                      }))}
            </>
            <br />
            <br />
          </p>
          <p
            style={{
              lineHeight: '1.4em',
              marginTop: '30px'
            }}
          >
            <Labels chartTitle>
              {lang === 'de' ? (
                <>
                  Diese Getränke werden von den {voteStats.sum} Teilnehmenden am
                  häufigsten konsumiert
                </>
              ) : (
                <>
                  Ces boissons sont le plus souvent consommées par les{' '}
                  {voteStats.sum}{" "}
                  participants au sondage
                </>
              )}
            </Labels>
          </p>
          <ColumnChart
            lang={lang}
            data={drinkCounts}
            userSingle={userDrinksMix}
          />
          <p>
            {mostPopularMix &&
              userDrinksMostPopularMix !== undefined &&
              mostPopularMixPercent !== undefined &&
              userDrinksMixPercent !== undefined &&
              (lang === 'de'
                ? Textbuilder()
                    .add(
                      'Die beliebteste Kombination der Teilnehmenden besteht aus '
                    )
                    .break()
                    .array2List(mostPopularMix, { each: ',', last: ' und' })
                    .add('.')
                    .break()
                    .conditional(userDrinksMostPopularMix, {
                      true: ' Das entspricht also genau Ihrem Geschmack. ',
                      false: ' '
                    })
                    .break()

                    .num(mostPopularMixPercent, { digits: 0, style: 'percent' })
                    .add(' Prozent')
                    .break()
                    .add(' trinken so Kaffee.')
                    .break()
                    .array()
                    .map((m, i) => {
                      if ([2].includes(i)) {
                        return (
                          <Labels userRelation key={i}>
                            {m}
                          </Labels>
                        )
                      }

                      return <span key={i}>{m}</span>
                    })
                : Textbuilder()
                    .add(
                      'La combinaison la plus populaire parmi les participants se compose de '
                    )
                    .break()
                    .array2List(mostPopularMix, { each: ',', last: ' et' })
                    .break()
                    .conditional(userDrinksMostPopularMix, {
                      true: ', ce qui correspond donc exactement à votre goût. ',
                      false: '. '
                    })
                    .break()
                    .num(mostPopularMixPercent, { digits: 0, style: 'percent' })
                    .add(' pour cent')
                    .break()
                    .add(' boivent du café de cette manière.')
                    .break()
                    .array()
                    .map((m, i) => {
                      if ([2].includes(i)) {
                        return (
                          <Labels userRelation key={i}>
                            {m}
                          </Labels>
                        )
                      }

                      return <span key={i}>{m}</span>
                    }))}
           
          </p>
          <Labels chartTitle>
            {lang === 'de'
              ? 'Das sind die beliebtesten sechs Kombinationen'
              : 'Voici les six combinaisons les plus populaires'}
          </Labels>
          <DrinksMix
            lang={lang}
            totalPaticipants={voteStats.sum}
            data={combinationsOnly}
            userMix={userDrinksMix.includes('_') ? userDrinksMix : undefined}
          />
        </>
      )}
    </>
  )
}
